import { ReactElement } from "react";

import { SearchWorkflowTasksResponse } from "../../../../../../service/query";
import { Column, CursorDataGrid, FlyoutPanel, Row } from "../../../../../../widget";
import { useUpcomingTasksPanel } from "./useUpcomingTasksPanel";

interface UpcomingTasksPanelProps {
  groupUuid?: string;
  show: boolean;
  onClose: () => void;
  setSelectedPanelTask: (task: SearchWorkflowTasksResponse["results"][0] | undefined) => void;
  setShowWorkflowTaskPanel: (show: boolean) => void;
  refreshTasks: boolean;
}

export const UpcomingTasksPanel = ({
  groupUuid,
  show,
  onClose,
  setSelectedPanelTask,
  setShowWorkflowTaskPanel,
  refreshTasks,
}: UpcomingTasksPanelProps): JSX.Element => {
  const { columns, defaultSortingCriteria, dataIsLoading, onChange } = useUpcomingTasksPanel(
    groupUuid,
    setSelectedPanelTask,
    setShowWorkflowTaskPanel
  );

  const content = (): ReactElement => (
    <div className="UpcomingTasksPanelContent">
      <div className="UpcomingTasksTable">
        <Row>
          <Column span={12}>
            <CursorDataGrid
              columns={columns}
              clientSide={false}
              filterable
              onChange={onChange}
              sortable
              data={[]}
              refresh={refreshTasks}
              dataIsLoading={dataIsLoading}
              defaultSortingCriteria={defaultSortingCriteria}
              noDataMessage="No tasks to display"
            />
          </Column>
        </Row>
      </div>
    </div>
  );

  return (
    <FlyoutPanel
      show={show}
      onClose={onClose}
      size="Large"
      header="Upcoming tasks"
      contentChildren={content()}
      buttonsChildren={undefined}
    />
  );
};
